import React, { useEffect } from 'react';
import { getId, ResizeGopickFrame, ResizePowerballFrame } from '../../common/cores';


const MinigameCenter = (props) => {
    const { type } = props;

    // const url = getMinigameUrl(props.type)
    const { url } = props;
    // console.log(props.type, url);

    useEffect(()=>{
        ResizeGopickFrame();
        ResizePowerballFrame();
    }, [type])
    // console.log(url)
    return (
            <div className="widgets column" style={{ maxWidth: "800px", margin: "auto", width: "100%", padding: "15px" }}>
                <div className="iframe-view row" id={getId(type)} 
                    style={{ height: "640px", flexDirection: "row", display: "block" }}>
                    <iframe
                        className="frameScale betIframe"
                        scrolling="no"
                        frameBorder="0"
                        src={url} 
                        title="powerballIframe"
                    />
                </div>
            </div>
    );
};

export default MinigameCenter;


// WEBPACK FOOTER //
// ./src/components/Minigame/MinigameVideo.js